import React from 'react';

import { useTranslation } from "react-i18next";
import { makeStyles } from '@material-ui/core';
import { Error } from '@material-ui/icons';

import SquareAuthorisationButton from '../../components/SquareAuthorisationButton';

export interface IImportLocations {
    error: string | null;
    csrfToken: string | null;
}

const useStyles = makeStyles({

    wrapper: {
        borderRadius: "16px",
        border: "1px solid #E8EAF4",
        padding: "1.5rem 2.4rem"
    },
    explanation: {
        marginTop: "0"
    },
    errorWrapper: {
        marginBottom: "1.8rem",
        display: "flex",
        alignItems: "center"

    },
    errorIcon: {
        flex: "0 0 2.5rem",
    },
    errorMessage: {
        flex: "1 1 auto"
    },
    error: {
        color: "#F65164",
    },
    bold: {
        fontWeight: 600,
    }
})

const ImportLocations = (props: IImportLocations) => {
    const classes = useStyles();
    
    const { t } = useTranslation();



    return (
        <>
            <h3>{t("signup.importer.import_locations")}</h3>
            <div className={classes.wrapper}>
                <p className={classes.explanation}>{t("signup.importer.import_explanation")}</p>
                {   
                    props.error && 
                        <div className={classes.errorWrapper}>
                            <div className={classes.errorIcon}>
                                <Error htmlColor={"#F65164"} />
                            </div>
                            <div className={classes.errorMessage}>
                                <div className={`${classes.error} ${classes.bold}`} >{t("signup.importer.square_auth_error")}</div>
                                <div className={classes.error}>{t("signup.importer.square_auth_description")}</div>
                            </div>
                        </div>
                }
                <SquareAuthorisationButton 
                    csrfToken={props.csrfToken} 
                    enabledText={t("signup.importer.import_locations")}
                    disabledText={t("signup.importer.connecting_square")}
                />
            </div>
        </>
    )
}

export default ImportLocations;